import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Articolo from "@/pages/articolo/page";
import Sicurezza from "@/pages/sicurezza/page";
import Confronto from "@/pages/confronto/page";
import Glossario from "@/pages/glossario/page";
import GuidaAcquisti from "@/pages/guida-acquisti/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/articolo/",
    element: <Articolo />,
  },
  {
    path: "/sicurezza/",
    element: <Sicurezza />,
  },
  {
    path: "/confronto/",
    element: <Confronto />,
  },
  {
    path: "/glossario/",
    element: <Glossario />,
  },
  {
    path: "/guida-acquisti/",
    element: <GuidaAcquisti />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;